import { render, staticRenderFns } from "./EndpointNotifications.vue?vue&type=template&id=da1c5f3a"
import script from "./EndpointNotifications.vue?vue&type=script&lang=js"
export * from "./EndpointNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports